module.exports = __webpack_public_path__ + "static/media/everyday_digital.174c8cff.webp";